import type { SxProps } from "@mui/material";
import { Colors } from "../../utils/constants";

const root: SxProps = {
  width: "100%",
  px: {xs:"10px", sm:"48px"},
  py: 2,

  gap: 3,
};

const heading: SxProps = {
  fontSize: "24px",
  fontWeight: 700,
};

const historyTable: SxProps = {
  width: "100%",
  gap: 1,
};

const tableHead: SxProps = {
  height: "46px",
  background: "#F9FAFB",
  //   maxWidth: "1460px",
     border: "1px solid #D1D5DB",
  borderRadius: "8px 8px 0px 0px",
  backgroundColor:"#f2f2f2",

};

const actionBar: SxProps = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 2,
};

const card: SxProps = {
  borderRadius: 1,
  p: 2,
  pb:4,
  flex:1,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const example: SxProps = {
  fontSize: "14px",
  fontStyle: "italic",
  color: "gray",
}

const viewResult: SxProps = {
  textDecoration: "underline",
  color: Colors.primary,
  fontSize: "0.875rem",
  mr: 3,
  "&:hover": {
    cursor: "pointer",
  },
  textAlign: "start",
  width: 200
};

const fieldArray: SxProps = {};

const BorderStyles  = { borderRight: '1px solid #ddd'};


export const searchHistoryStyles = {
  root,
  heading,
  historyTable,
  tableHead,
  actionBar,
  card,
  fieldArray,
  BorderStyles,
  example,
  viewResult
};
